import React, { Ref, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useMutation, useQuery } from '../../convex/_generated/react'

import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Select,
  Button,
  useDisclosure
} from '@chakra-ui/react'
import { Project } from '../../types'
import { Id } from '../../convex/_generated/dataModel'
import ClientFormModal from '../Modals/ClientFormModal'

interface IProps {
  _id?: Id
  formRef ?: Ref<HTMLFormElement>
  onSuccess?: () => void
}

interface ProjectFormTypes extends Omit<Project, 'client' | '_id'> {
  client: string
}

const ProjectForm: React.FC<IProps> = ({ _id, onSuccess, formRef }) => {
  const currentProject = useQuery('projectById', _id || null)
  const clientsList = useQuery('listClients')
  const {
    isOpen: isNewClientModalOpen,
    onOpen: openNewClientModal,
    onClose: closeNewClientModal
  } = useDisclosure()

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset
  } = useForm<ProjectFormTypes>()

  // Convert ID to string (for client) for the form values
  useEffect(() => {
    const transformedProject = {
      ...currentProject,
      client: currentProject?.client?.toString()
    }
    reset(transformedProject)
  }, [currentProject, clientsList])

  const createProject = useMutation('createProject')
  const updateProject = useMutation('updateProject')

  const onSubmit = async (data: ProjectFormTypes) => {
    // Transform Form Project to actual Project data
    const transformedProject = {
      ...data,
      client: new Id('clients', data.client)
    }

    if (_id) {
      updateProject({ ...transformedProject, _id })
      onSuccess && onSuccess()
      return
    }

    await createProject(transformedProject)
    onSuccess && onSuccess()
  }

  return (
    <>
      <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
        <FormControl>
          <FormLabel>Project name</FormLabel>
          <Input {...register('name')} placeholder='Name of company' />
          <FormErrorMessage>
            {errors.name && errors.name.message}
          </FormErrorMessage>
        </FormControl>

        <FormControl mt={4}>
          <FormLabel>Start date</FormLabel>
          <Input {...register('startDate')} placeholder='Start date' />
          <FormErrorMessage>
            {errors.startDate && errors.startDate.message}
          </FormErrorMessage>
        </FormControl>

        <FormControl mt={4}>
          <FormLabel>End date</FormLabel>
          <Input {...register('endDate')} placeholder='End date' />
          <FormErrorMessage>
            {errors.endDate && errors.endDate.message}
          </FormErrorMessage>
        </FormControl>

        <FormControl mt={4}>
          <FormLabel>Client</FormLabel>
          <Select {...register('client')} placeholder='Select client'>
            {
              clientsList?.map(
                client =>
                  <option
                    key={client._id?.toString()}
                    value={client._id?.toString()}
                  >
                    { client.name }
                  </option>
              )
            }
          </Select>
          <Button onClick={openNewClientModal} style={{ marginTop: 10 }}>New Client</Button>
          {/*
          <FormErrorMessage>
            {errors.client && errors.client.message}
          </FormErrorMessage>
          */}
        </FormControl>
      </form>
      <ClientFormModal
        isOpen={isNewClientModalOpen}
        onClose={closeNewClientModal}
      />
    </>
  )
}

export default ProjectForm
